import http from "@/services/http";

/**
 * Recados médico <-> assistente: bidirecional, direcionado a uma pessoa, com
 * respostas em thread. Qualquer participante responde e marca como resolvido.
 */

/** Clínicas do usuário + destinatários elegíveis (papel oposto) em cada uma. */
export async function getComposeTargets() {
  const { data } = await http.get("/api/assistant-notes/compose-targets");
  return data?.data || [];
}

/** Caixa unificada: recados enviados + recebidos (com respostas). */
export async function getInbox() {
  const { data } = await http.get("/api/assistant-notes/inbox");
  return {
    notes: data?.data || [],
    pendingCount: data?.pending_count || 0,
  };
}

/** Cria um recado direcionado. payload: { clinic_id, recipient_id, message } */
export function createAssistantNote(payload) {
  return http.post("/api/assistant-notes", payload);
}

/** Responde a um recado. */
export function replyToAssistantNote(id, message) {
  return http.post(`/api/assistant-notes/${id}/replies`, { message });
}

/** Marca um recado como resolvido (qualquer participante). */
export function resolveAssistantNote(id) {
  return http.put(`/api/assistant-notes/${id}/resolve`);
}

/** Apaga um recado (apenas o autor). */
export function deleteAssistantNote(id) {
  return http.delete(`/api/assistant-notes/${id}`);
}

/**
 * @deprecated Use getInbox(). Mantido para UserMenu/AssistantNotesDialog (visão
 * do assistente): a caixa unificada já cobre os recados recebidos.
 */
export const getAssistantNotesForAssistant = getInbox;
